/**
 * Display-grade parse of the canonical WORKFLOW.md `## Step N — title`
 * sections (U12). The agents repo's serializer guarantees this shape;
 * anything unparseable falls back to the caller showing raw markdown —
 * never a crash on a stored file.
 */

export interface DisplayStep {
  readonly index: number;
  readonly title: string;
  readonly instruction: string;
}

export function parseStepsForDisplay(markdown: string): readonly DisplayStep[] {
  const steps: DisplayStep[] = [];
  const re = /^## Step (\d{1,4})(?:[ \t]{0,10}[—:–-][ \t]{0,10}(.{0,300}))?$/gm;
  const matches = [...markdown.matchAll(re)];
  for (let i = 0; i < matches.length; i++) {
    const m = matches[i];
    const start = m.index + m[0].length;
    const end =
      i + 1 < matches.length ? matches[i + 1].index : markdown.length;
    steps.push({
      index: Number(m[1]),
      title: (m[2] as string | undefined)?.trim() ?? '',
      instruction: markdown.slice(start, end).trim(),
    });
  }
  return steps;
}
